import { Easing } from "remotion";

// Easing functions from https://easings.net/

export const linear = (t: number) => t;

export const easeInCubic = Easing.bezier(0.32, 0, 0.67, 0);
export const easeOutCubic = Easing.bezier(0.33, 1, 0.68, 1);
export const easeInOutCubic = Easing.bezier(0.65, 0, 0.35, 1);

export const easeOutBack = Easing.bezier(0.34, 1.56, 0.64, 1);
export const easeInOutBack = Easing.bezier(0.68, -0.6, 0.32, 1.6);

export const easeInCirc = Easing.bezier(0.55, 0, 1, 0.45);
export const easeOutCirc = Easing.bezier(0, 0.55, 0.45, 1);
export const easeInOutCirc = Easing.bezier(0.85, 0, 0.15, 1);

export const easeInSine = Easing.bezier(0.12, 0, 0.39, 0);
export const easeOutSine = Easing.bezier(0.61, 1, 0.88, 1);
